import { DEBT_DETAIL_PAGE } from "routes/route.constant";
import DetailDebt from "./DetailDebt";

const route = {
  path: DEBT_DETAIL_PAGE,
  element: DetailDebt,
};

export default route;
